export default __webpack_public_path__ + "static/media/eh2.c3d77a0e.png";